





import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import {Getter, Mutation} from "vuex-class";
import axios from "axios";
import VisualComponent from "@/valchrom/views/mathservice/dataset/overview/VisualComponent.vue";

@Component({
    components: {
        VisualComponent,

    }
})
export default class NewReportContentGenerator extends Vue {
    dataLoaded: boolean = false;
    @Mutation CHANGE_OVERVIEW_SIMPLIFY!: (_ : boolean) => any; //TODO: add type
    @Prop() datasetId !:number ;
    @Getter math_service_url !: any;
    @Getter token !: any;
    response: any = {overview:null};

    reload(){
        if(this.dataLoaded){
            this.setLoading(true);
            this.setLoading(false);
            this.waitRender(this.emitReportHtml);

        } else {
            this.loadData();
        }
    }

    @Emit('loadingState')
    emitLoadingState() {
        return !this.dataLoaded
    }

    mounted () {
        this.setLoading(true);
        this.CHANGE_OVERVIEW_SIMPLIFY(true);

        this.loadData();
    }

    private loadData() {
        let self = this;
        let outputUrl = this.math_service_url+"dataset/"+
            this.datasetId+"/output/";
        console.log("GET from ",outputUrl);
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        axios
            .get(
                outputUrl,
                {
                    headers: {
                        jwt: this.token
                    },
                    withCredentials: true
                }
            )
            .then(response => {
                console.log("Got response",response);
                this.response.overview = response.data.overview;
                self.setLoading(false);

                self.waitRender(self.emitReportHtml);
            })
            .catch(error => {
                self.setLoading(false);
                console.log("error on GET dataset info", error);
            });
    }

    private setLoading(value: boolean) {
        this.dataLoaded = !value;
        this.emitLoadingState();
    }

    private waitRender(callback: ()=> void) {
        setTimeout(()=>{
            callback();
        },1000);
    }

    @Emit('reportHtml')
    private emitReportHtml() {
        console.log("this.$refs.content", this.$refs.content);
        let innerHTML = ((this.$refs.content as any).$el as Element).innerHTML;
        console.log("this.$refs.content.innerHTML", innerHTML);
        return innerHTML;
    }
}
